import Rive from '@rive-app/react-canvas';
import {useCallback, useState} from 'react';
import {AuthBox} from '../../../../components/auth';
import {FindOutMoreContent, SkipWorkExperienceButton} from '../../../../components/onboarding';
import {segmentTrack} from '../../../../utils';
import {Form} from './Form';

type Props = {
  onSuccess: () => void;
  blueUserUrl?: string;
};

export const FormScreen = ({onSuccess, blueUserUrl}: Props) => {
  const [isFindOutMoreOpen, setIsFindOutMoreOpen] = useState(false);
  const toggleFindOutMore = useCallback(() => {
    setIsFindOutMoreOpen(!isFindOutMoreOpen);
    segmentTrack('Button clicked', {
      label: 'find out more',
      location: 'add overlaps',
    });
  }, [isFindOutMoreOpen]);

  return (
    <AuthBox
      headerImage={
        <Rive
          src="/animations/workoverlaps.riv"
          className="h-[300px] w-full rounded border border-swarm-gray-400"
        />
      }
      headerTitle="Work and Education Overlaps"
      headerDescription={
        <>
          First, we automatically find people you may know based on your experience.{' '}
          <a
            className="mx-auto mb-4 cursor-pointer text-swarm-gray-700 underline"
            onClick={toggleFindOutMore}
          >
            Learn more
          </a>
        </>
      }
    >
      <FindOutMoreContent
        visible={isFindOutMoreOpen}
        content={
          'By analyzing the companies you\'ve worked for, your roles, school, and timeframes, we\'ll find hundreds of "overlaps" and match them with our extensive database of millions of profiles!'
        }
      />

      <Form onSuccess={onSuccess} blueUserUrl={blueUserUrl} />

      <SkipWorkExperienceButton visible={isFindOutMoreOpen} afterSkip={onSuccess} />
    </AuthBox>
  );
};
